/* eslint-disable */
import React, { Component } from "react";
import find from "lodash/find";
import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";
import { connect } from "react-redux";
import moment from "moment";
import Heading from "../Heading";
import {
  getColumn,
  handleBidUpsert,
  isMobile,
} from "../../DiamondList/DiamondListFunctions";
import Table from "../../DiamondList/TableBack";
import { calculate, formatNumber } from "./SelectStone";
import { getBidType } from "../../NewArrivalBidIt";
import { getExtraPer, newDiamondPriceWithType } from "./FinalCalculations";
import { HeadingCalc } from "./ConfirmStonePopup";
import { DIAMOND_BID } from "../../../constants/Common";
import BIDStoneMobile from "./BIDStoneMobile";
import OpenNotification from "../CommonButton/OpenNotification";
import IntlMessages from "../../../util/IntlMessages";

const currentType = "bidStones";

class BidPopup extends Component {
  state = {
    columns: [],
    checked: [],
    data: [],
    currentBidType: 0,
  };

  getNewBid = (stoneId, minus) => {
    let data = cloneDeep(this.state.data);
    let index = findIndex(data, { stoneId });
    let orgData = find(this.props.checked, { stoneId });
    let bidtype = 0;
    this.props.data.map((datas) => {
      if (datas.stoneId === stoneId)
        bidtype = datas.bidTType ? datas.bidTType : datas.bidType;
    });
    let val = minus
      ? bidtype === 1 || bidtype === 2
        ? data[index].bidPricePerCarat - 20
        : parseFloat(orgData?.bidPricePerCarat) >
          parseFloat(parseFloat(data[index].bidPricePerCarat) - 20)
        ? data[index].bidPricePerCarat
        : data[index].bidPricePerCarat - 20
      : data[index].bidPricePerCarat + 20;
    if (val < data[index].ctPr && minus) return;
    data[index].bidPricePerCarat = val;

    const discount = (val * 100) / data[index].rap - 100;
    const ctPr =
      data[index].rap + (data[index].rap * discount.toFixed(2)) / 100;
    // if(window.shortpath() === '/my-bid')
    data[index].bidAmount =
      (ctPr ? ctPr : data[index].bidPricePerCarat) * data[index].crt;

    let sum = calculate([
      { ...data[index], ctPr: val, amt: data[index].bidAmount },
    ]);
    data[index].bidDiscount = sum.final_discount;
    data[index] = newDiamondPriceWithType(
      data[index],
      "bid",
      this.state.currentBidType,
    );
    this.setState({ data }, () => {
      let checked = this.state.data.filter((el) =>
        find(this.state.checked, { id: el.id }),
      );
      this.setState({ checked });
    });
  };

  getBidPrCell = (row) => {
    return (
      <div className="tableInput">
        <img
          src={require("../../../assets/svg/minus.svg")}
          alt="minus"
          width="14px"
          className="mr-5"
          onClick={() => this.getNewBid(row.stoneId, true)}
        />
        <input style={{ width: "70%" }} value={row?.bidPricePerCarat} />
        <img
          src={require("../../../assets/svg/plus-dis.svg")}
          alt="plus"
          width="14px"
          className="ml-5"
          onClick={() => this.getNewBid(row.stoneId, false)}
        />
      </div>
    );
  };

  async componentDidMount() {
    const bidType = await getBidType();
    let data = this.props.checked
      .map((x) => ({
        ...x,
        bidPricePerCarat: Math.round(
          parseFloat(
            (x?.bidPricePerCarat ? x?.bidPricePerCarat : x?.ctPr) || 0,
          ),
        ),
        bidAmount: x?.bidAmount ? x?.bidAmount : x?.amt,
        bidDiscount: window.shortPath() === "my-bid" ? x?.bidDiscount : x?.back,
      }))
      .map((x) => newDiamondPriceWithType(x, "bid", bidType));
    let Columns = getColumn();
    let index = findIndex(Columns, { id: "rap" });
    if (!index) index = 1;
    let columns = [
      ...Columns.slice(0, index + 1).filter(
        (el) => !["back", "amt", "ctPr"].includes(el.id),
      ),
      find(Columns, { id: "back" }),
      find(Columns, { id: "ctPr" }),
      find(Columns, { id: "amt" }),
      {
        Header: "Bid Price/Ct",
        accessor: "bidPricePerCarat",
        id: "bidPricePerCarat",
        width: 230,
        Cell: ({ row }) => this.getBidPrCell(row.original),
      },
      {
        Header: "Bid Disc(%)",
        accessor: "bidDiscount",
        id: "bidDiscount",
        Cell: ({ row }) => (
          <div className="tableInput">
            <input
              value={parseFloat(row.original.bidDiscount || 0).toFixed(2)}
            />
          </div>
        ),
      },
      {
        Header: "Bid Value",
        accessor: "bidAmount",
        id: "bidAmount",
        Cell: ({ row }) => (
          <div className="tableInput">
            <input value={parseFloat(row.original.bidAmount || 0).toFixed(2)} />
          </div>
        ),
      },
      {
        Header: "Less",
        accessor: "less",
        id: "less",
        Cell: ({ row }) => (
          <>
            {/* {parseFloat(getExtraPer()).toFixed(2) + (bidType === DIAMOND_BID.TYPE.BLIND ? " + 0.5" : "")} */}
            {this.getLessValue(row.original)}
          </>
        ),
      },
      {
        Header: "Final Disc(%)",
        accessor: "fnBack",
        id: "fnBack",
        Cell: ({ row }) => (
          <>{parseFloat(row.original.calcDiscount).toFixed(2)}</>
        ),
      },
      {
        Header: "Final Rate",
        accessor: "fnCtpr",
        id: "fnCtpr",
        Cell: ({ row }) => (
          <>{parseFloat(row.original.calcPricePerCarat).toFixed(2)}</>
        ),
      },
      {
        Header: "Final Value",
        accessor: "fnAmt",
        id: "fnAmt",
        Cell: ({ row }) => (
          <>{parseFloat(row.original.calcAmount).toFixed(2)}</>
        ),
      },
      ...Columns.slice(index + 1, Columns.length).filter(
        (el) => !["back", "amt", "ctPr"].includes(el.id),
      ),
    ].filter((el) => el && el);
    this.setState({ currentBidType: bidType, columns, data, checked: data });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.checkedData.length !== this.state.checked.length) {
      this.setState({
        checked: this.state.data.filter((x) =>
          find(nextProps.checkedData, { id: x?.id }) ? true : false,
        ),
      });
    }
  }

  checkCheck = () => {
    if (!this.state.checked.length) {
      OpenNotification({
        type: "error",
        title: "Please select stone(s) to bid.",
      });
      return false;
    } else return true;
  };

  submit = async () => {
    let self = this;
    if (!this.checkCheck()) return;
    const bidType = await getBidType();
    this.props.handleLoader(true);

    handleBidUpsert(this.state.checked, bidType, (flag) => {
      self.props.onClose();
      self.props.clearAll();
      this.props.handleLoader(false);
      if (flag && self.props.fetch) self.props.fetch();
    });
  };

  getLessValue = (data) => {
    const currentDateTime = moment().toISOString();
    if (
      currentDateTime >= data.blndBidStrTm &&
      currentDateTime <= data.blndBidEndTm
    ) {
      return data?.blndBidBack?.[1]
        ? `${(data?.blndBidBack?.[0] || 0).toFixed(2)} + ${
            data?.blndBidBack?.[1]
          }`
        : `${(data?.blndBidBack?.[0] || 0).toFixed(2)}`;
    } else if (
      currentDateTime >= data.lABidStrTm &&
      currentDateTime <= data.lABidEndTm
    ) {
      return data?.lABidBack?.[1]
        ? `${(data?.lABidBack?.[0] || 0).toFixed(2)} + ${data?.lABidBack?.[1]}`
        : `${(data?.lABidBack?.[0] || 0).toFixed(2)}`;
    } else if (
      currentDateTime >= data.mulBidStrTm &&
      currentDateTime <= data.mulBidEndTm
    ) {
      return data?.mulBidBack?.[1]
        ? `${(data?.mulBidBack?.[0] || 0).toFixed(2)} + ${
            data?.mulBidBack?.[1]
          }`
        : `${(data?.mulBidBack?.[0] || 0).toFixed(2)}`;
    } else return parseFloat(getExtraPer()).toFixed(2);
  };

  render() {
    let summation = calculate(this.state.checked, true);
    let totalCarat = parseFloat(summation.total_carat).toFixed(2);
    let netValue = formatNumber(parseFloat(summation.final_value).toFixed(2));
    let avgDisc = parseFloat(summation.final_discount).toFixed(2);
    let finalAvgDisc = parseFloat(summation.final_term_discount).toFixed(2);
    let finalNetRate = formatNumber(
      parseFloat(summation.final_rate).toFixed(2),
    );
    let finalNetValue = formatNumber(
      parseFloat(summation.final_net_value).toFixed(2),
    );
    let VALUES = isMobile()
      ? {
          "CT.:": totalCarat,
          "Final Disc%:": finalAvgDisc,
          "Amount:": netValue,
          "Final Rate:": finalNetRate,
          "Disc%:": avgDisc,
          "Final Value:": finalNetValue,
        }
      : [
          { title: "Total Carats", value: totalCarat },
          { title: "Final Net Rate", value: finalNetRate },
          { title: "Avg. Discount", value: avgDisc },
          { title: "Final Avg Discount", value: finalAvgDisc },
          { title: "Net Value", value: netValue },
          { title: "Final Net Value", value: finalNetValue },
        ];

    return isMobile() ? (
      <BIDStoneMobile
        {...this.state}
        currentType={currentType}
        onClose={this.props.onClose}
        VALUES={VALUES}
        parent={this}
      />
    ) : (
      <div>
        <div className="d-flex align-items-center offerTopBlock offerWrapper mb-20">
          <Heading
            className="popupInnerTitle mr-20"
            title={<IntlMessages id="app.bidStone" />}
          />
          {HeadingCalc(this.state.checked)}
        </div>
        <div className="searchPopupCommonTable">
          <div className="searchResultTable tabInnerTableScroll">
            <Table
              {...this.state}
              nodots
              areAllChecked={true}
              handleCheck={(e) => this.setState({ checked: e })}
              currentType={currentType}
              canSort={false}
              noGrp
              FilterOption={false}
            />
          </div>
          <div className="mt-10 finalCalDetail">
            <div className="DiamondDetailPopup">
              {VALUES.map((x) => (
                <div className="DiamondDetailPopupItem">
                  <span>{x?.title} : </span>
                  <span>{x?.value}</span>
                </div>
              ))}
            </div>
            {this.props.currentType !== "/new-arrival-bid-it" &&
            (parseFloat(getExtraPer()).toFixed(2) > 0 ||
              this.state.currentBidType === DIAMOND_BID.TYPE.BLIND) ? (
              <p className="offerNote mt-20">
                <b>
                  {" "}
                  <IntlMessages id="app.Note" />:{" "}
                </b>{" "}
                <IntlMessages id="app.bidNote1" />{" "}
                {parseFloat(getExtraPer()).toFixed(2)}
                {this.state.currentBidType === DIAMOND_BID.TYPE.BLIND
                  ? "+0.5"
                  : ""}{" "}
                % <IntlMessages id="app.bidNote2" />
              </p>
            ) : (
              ""
            )}
          </div>
          <div className="sideBarPopupButton">
            <a id="bid-stone" className="commonButton" onClick={this.submit}>
              <IntlMessages id="app.bidStone" />
            </a>
            <a className="commonButton" onClick={this.props.onClose}>
              <IntlMessages id="app.CancelBid" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ diamondData }) => {
  return { checkedData: diamondData.selectedRows[currentType] || [] };
};

export default connect(mapStateToProps, null)(BidPopup);
